export default __webpack_public_path__ + "static/media/logo_pnj_login_right.0220855f.png";